import { gql } from '@apollo/client'
import { query } from '../helpers/graphql'

const queryPartial = `
          property_name
          is_active
          external_properties {
            external_property_id
            account_id
          }
          properties_configuration_options {
            supports_floor_plan_screen_in_cort_widget
            animate_unit_model_from_top_view
          }
          id
          logo_path
          property_name
          real_estate_company {
            id
            company_name
            company_logo
          }
          unit_types {
            id
            name
            number_of_bathrooms
            number_of_bedrooms
            size
            size_to_display
            nick_name
            unit_types_configuration_options {
              is_mirrored
              hide_line_pill
              default_selected
              id
            }
            units {
                name
                id
            }
            packages {
              id
              description
              name
              show_by_default
              price
              display_name
              terms_and_conditions
              design_layouts {
                photos {
                  src
                  id
                }
                 unit_type_level {
                   id
                   unit_type {
                     id
                   }
                 }
              }
              room_classifications {
                categories
                icon
                room_classification {
                  id
                  weight
                  classification_name
                }
              }
              vendor {
                logo_path
                display_name
                id
                full_name
                privacy_policy_url
              }
              unit_plans {
                id
                src
                contains_angle
                scale_factor
                unit_type_level {
                  id
                }
                vendor {
                  id
                  full_name
                }
                design_layout {
                  id
                  main_vendor {
                    id
                    full_name
                  }
                  models {
                    id
                    low_res_model_path
                    low_res_polygons_count
                    high_res_model_path
                    high_res_polygons_count
                    initial_gravity_rotation_angle
                    scale
                  }
                }
                unit_type_level {
                  id
                  is_entrance
                  floor_number
                  display_name
                  unit_type {
                    size
                    size_to_display
                  }
                  design_layouts {
                    id
                    main_vendor {
                      id
                      full_name
                    }
                    models {
                      id
                      low_res_model_path
                      low_res_polygons_count
                      high_res_model_path
                      high_res_polygons_count
                      initial_gravity_rotation_angle
                    }
                    package {
                      id
                    }
                  }
                }
              }
            }
            unit_type_levels {
              id
              is_entrance
              floor_number
              display_name
              unit_type {
                size
                size_to_display
              }
              design_layouts {
                id
                main_vendor {
                  id
                  full_name
                }
                models {
                  id
                  low_res_model_path
                  low_res_polygons_count
                  high_res_model_path
                  high_res_polygons_count
                  initial_gravity_rotation_angle
                  scale
                }
                package {
                  id
                }
              }
            }
          }
        
`
export async function getPropertyById(propertyId, default_only = false) {
  return await query({
    variables: {
      propertiesByIdId: Number(propertyId),
      filters: {
        include_in_sparx_living: true,
        only_selected_line_for_smart_floorplan: default_only
      },
    },
    query: gql`
      query Properties_by_id($propertiesByIdId: Int!, $filters: property_by_id_filters) {
        properties_by_id(id: $propertiesByIdId, filters: $filters) {
          ${queryPartial}
        }
      }
    `,
  })
}

export async function getPropertyByExternalId(externalId, default_only = false) {
  return await query({
    variables: {
      externalId: externalId,
      filters: {
        only_selected_line_for_smart_floorplan: default_only
      },
    },
    query: gql`
      query Properties_by_external_id($externalId: String!, $filters: property_by_external_id_filters) {
        properties_by_external_id(external_id: $externalId, filters: $filters) {
          ${queryPartial}
        }
      }
    `,
  })
}

export async function getPropertyByUnitName(name, default_only = false) {
  return await query({
    variables: {
      name,
      filters: {
        include_in_sparx_living: true,
        only_selected_line_for_smart_floorplan: default_only,
      },
    },
    query: gql`
      query Properties_by_unit_name($name: String!, $filters: property_by_unit_name_filters) {
        properties_by_unit_name(unit_name: $name, filters: $filters) {
          ${queryPartial}
        }
      }
    `,
  })
}
